import { CheckBoxFieldTheme } from 'components/Form/CheckBoxField/CheckBoxField.types';
import colors from 'style-utils/theme/themeProperties/colors';

const checkboxSecondaryVariantTheme: CheckBoxFieldTheme = {
  checkBoxWrapper: {
    style: {
      alignItems: 'flex-start',
      gap: '1.2rem',
    },
  },
  checkBoxInput: {
    style: {
      borderRadius: '.2rem',
    },
  },
  checkBoxLabel: {
    style: {
      fontFamily: 'Muli',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '1.2rem',
      lineHeight: '1.6rem',
      color: colors.textPrimary,
    },
  },
};

export default checkboxSecondaryVariantTheme;
